import Block from "../../../components/Block/Block"
import FadeIn from "../../../components/FadeIn/FadeIn"
import ImageGalleryGrid from '../ImageGalleryGrid/ImageGalleryGrid'
import VideoGalleryGrid from "../VideoGalleryGrid/VideoGalleryGrid"

import style from './galleryblock.module.scss'

const GalleryBlock = () => {
    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background="rgba(255, 255, 255, 0.85)"
            header='ГАЛЕРЕЯ'
            id='gallery'
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        <div className={style.row}>
                            <h4 className={style.header}>
                                Фото с мероприятий и тренировок
                            </h4>
                            <div className={style.text}>
                                <p>Наша школа регулярно проводит соревнования, сборы и спортивные праздники. 
                                Здесь вы можете увидеть моменты из жизни школы.</p>
                            </div>
                        </div>

                        <ImageGalleryGrid />

                        <div className={style.videoSection}>
                            <h4 className={style.header}>
                                Видеоматериалы
                            </h4>

                            <VideoGalleryGrid />

                        </div>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default GalleryBlock